<template>
    <div class="element CustomCommissionField" :data-required="this.required">
        <input
            class="hidden"
            type="hidden"
            :id="`field_${this.id}`"
            :name="this.name"
            :readonly="true"
            :autocomplete="off"
            v-model="input"
        />
        <table class="table" cellpadding="0" cellspacing="0" border="0">
            <thead>
            <tr>
                <td class="td_product">{{ trans("Product")}}</td>
                <td class="td_type">{{ trans("Type (€/%)") }}</td>
                <td class="td_amount">{{ trans("Waarde") }}</td>
                <td class="td_uitbetalignswijze">{{ trans("Afwijkende uitbetalingswijze")}}</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(product, index) in products" :key="index">
                <td class="td_product">
                    <input type="hidden" v-model="product.workflowcard_id" />
                    <div class="input">{{ product.title }}</div>
                </td>
                <td class="td_type">
                    <select class="input" v-model="product.type">
                        <option value=""> </option>
                        <option value="Percentage">Percentage (%)</option>
                        <option value="Vast bedrag">Vast bedrag (€)</option>
                    </select>
                </td>
                <td class="td_amount">
                    <input class="input"
                           type="text"
                           v-model="product.value"
                           @input="formatInput(product)"
                           @blur="formatInput(product)"
                    />
                </td>
                <td class="td_uitbetalignswijze">
                    <select class="input" v-model="product.uitbetalingswijze">
                        <option v-for="option in uitbetalingswijzeOptions" :key="option.key" :value="option.key">
                            {{ option.title }}
                        </option>
                    </select>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import {ref, watch, computed, onMounted, inject} from "vue";

// Our form helpers
import useFormValidation from "./_validation";
import { propDefaults } from "./_props";

import { getWorkflowpropertiesByNames } from "store/workflow";
import { addNotification } from "store/notifications";

// Our helpers
import { mergeDeep } from "helpers/_objects";
import trans from "helpers/_translation";

import Icon from "components/icon";

import { resolveProps } from "formbuilder/fields/_props";
import labelElement from "formbuilder/elements/LabelElement.vue";

export default {
    props: mergeDeep(
        propDefaults,
        {

        }
    ),
    components: {
        Icon,
        labelElement
    },
    setup(props) {

        let input = ref("");

        const products = ref([
            { workflowcard_id: 299, title: "Bouwkundige keuring", type: "", value: "", uitbetalingswijze: "" },
            { workflowcard_id: 300, title: "Energielabel Woning", type: "", value: "", uitbetalingswijze: "" },
            { workflowcard_id: 399, title: "Energielabel Woning Nieuwbouw", type: "", value: "", uitbetalingswijze: "" },
            { workflowcard_id: 400, title: "Energielabel Utiliteit", type: "", value: "", uitbetalingswijze: "" },
            { workflowcard_id: 401, title: "Maatwerkadvies Woning", type: "", value: "", uitbetalingswijze: "" },
            { workflowcard_id: 402, title: "Maatwerkadvies Utiliteit", type: "", value: "", uitbetalingswijze: "" },
        ]);


        const handleValue = (value) => {
            if (!value) {
                return;
            }
            products.value.forEach((product) => {
                const found = value.find((p) => `${p.workflowcard_id}` === `${product.workflowcard_id}`);
                if (found) {
                    product.type = found.type;
                    product.value = found.value;
                    product.uitbetalingswijze = found.uitbetalingswijze || "";
                }
            });
        };

        onMounted(() => {
            watch(
                () => props.value,
                () => {
                    input.value = props.value;
                    console.log("input.value",input.value);

                    if (typeof props.value === "object") {
                        handleValue(props.value);
                    } else if (typeof props.value === "string") {
                        // try catch json string
                        try {
                            handleValue(JSON.parse(props.value));
                        } catch (e) {
                            console.log("Error parsing JSON", e);
                        }
                    }
                },
                {
                    immediate: true
                }
            );

            watch(
                () => jsonOutput.value,
                () => {
                    input.value = jsonOutput.value;
                }
            );
        });

        const jsonOutput = computed(() => {
            return JSON.stringify(products.value, null, 2);
        });

        const formatInput = (product) => {
            if (!product.value) {
                return;
            }
            product.value = product.value.replace(/[^0-9,]/g, '');
            const parts = product.value.split(",");
            if (parts.length > 2) {
                product.value = parts[0] + "," + parts.slice(1).join("");
            }
            if (parseFloat(product.value) > 1000) {
                product.value = 1000;
            }
        };

        const formatOnBlur = (product) => {
            if (!product.value) {
                return;
            }
            let numericValue = parseFloat(product.value.replace(",", "."));
            if (!isNaN(numericValue)) {
                product.value = numericValue.toLocaleString("nl-NL", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                    useGrouping: numericValue % 1 !== 0
                });
            }
            if (parseFloat(product.value) > 1000) {
                product.value = 1000;
            }
        };

        // ambassadeurs_commissie_uitbetalingswijze
        const uitbetalingswijzeProperties = computed(() => {
            return getWorkflowpropertiesByNames([
                "ambassadeurs_commissie_uitbetalingswijze",
                // "ambassadeurs_commissie_uitbetalingswijze_schenking",
                // "ambassadeurs_commissie_uitbetalingswijze_waardebon"
            ]);
        });


        const uitbetalingswijzeOptions = computed(() => {

            // Based on the first property define our options and extend "Schenking" and "Waardebon" options with comma seperated options
            const uitbetalingswijzeProperty = uitbetalingswijzeProperties.value.find(a => a.name === "ambassadeurs_commissie_uitbetalingswijze");
            if (!uitbetalingswijzeProperty) {
                return [];
            }
            const options = [
                {
                    key: "",
                    value: "Volgens voorkeur"
                }
            ];
            const mainOptions = JSON.parse(uitbetalingswijzeProperty.options_json);
            Object.keys(mainOptions).forEach(key => {

                if (key === "Schenking" || key === "Waardebon") {
                    // const subProperty = uitbetalingswijzeProperties.find(a => a.name === `ambassadeurs_commissie_uitbetalingswijze_${key.toLowerCase()}`)
                    // if (!subProperty) {
                    //     return;
                    // }
                    //
                    // const subOptions = JSON.parse(subProperty.options_json);
                    // console.log("subOptions",subOptions);
                    // Object.keys(subOptions).forEach(subKey => {
                    //     options.push({
                    //         key: `${key}_${subKey}`,
                    //         title: `${mainOptions[key]}, ${subOptions[subKey]}`
                    //     });
                    // });
                    options.push({
                        key: key,
                        title: `${mainOptions[key]} (volgens voorkeur)`
                    });
                } else {
                    options.push({
                        key: key,
                        title: mainOptions[key]
                    });
                }
            });

            return options;
        });

        return {
            resolveProps,
            input,

            trans,
            products,

            jsonOutput,

            formatInput,
            formatOnBlur,

            uitbetalingswijzeOptions
        };
    },
}
</script>